import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer/customer.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class CustomerListComponent implements OnInit {
  public loading: boolean = false;
  public customersFilterProperty: string = '';
  public customersFilterDirection: string = 'asc';
  public customers: any;
  public filter: string = '';
  private originalCustomers: any;
  private sub: any;
  public p: any;

  constructor(public customerService: CustomerService) { }

  ngOnInit() {
    this.loading = true;
    this.customers = [];
    this.customerService.getCustomers().then(customers => {
      this.customers = customers;
      this.originalCustomers = customers;
      this.loading = false;
    }).catch(e => {
      this.loading = false;
    });
  }

  sortList(property: string, reverse: boolean = false) {
    this.customersFilterProperty = property;
    let array = this.customerService.all;
    if(property === 'erpCustomerID') { // temporary until all customer ERP ids get slowly added
      array.sort((a: any, b: any) => {
        if(b[property] === undefined) {
          b[property] = '';
        }
        if(a[property] === undefined) {
          a[property] = '';
        }
        return Number(b[property]) - Number(a[property]);
      });
    }
    else if (property === 'id') {
      array.sort((a: any, b: any) => {
        return Number(b[property]) - Number(a[property]);
      });
    }
    else {
      array.sort((a: any, b: any) => {
        var sorting = a[property].toUpperCase() > b[property].toUpperCase() ? 1 : -1;
        if (a[property].toUpperCase() === b[property].toUpperCase())
          sorting = 0;
        return sorting;
      });
    }
    if (reverse) {
      this.customersFilterDirection = 'desc';
      return array.reverse();
    } else {
      this.customersFilterDirection = 'asc';
      return array
    }
  }

  sortAsc(property: string) {
    let isSameProperty: boolean = property === this.customersFilterProperty;
    let isSameDirection: boolean = this.customersFilterDirection === 'asc';
    if ((isSameProperty && !isSameDirection) || !isSameProperty) {
      this.customersFilterDirection = 'asc';
      this.customers = this.sortList(property);
    }
  }

  sortDesc(property: string) {
    let isSameProperty: boolean = property === this.customersFilterProperty;
    let isSameDirection: boolean = this.customersFilterDirection === 'desc';
    if ((isSameProperty && !isSameDirection) || !isSameProperty) {
      this.customersFilterDirection = 'desc';
      this.customers = this.sortList(property, true);
    }
  }

  performQuickSearch() {
    let filter = new RegExp(`\w*${this.filter.trim()}\w*`, 'i');
    this.customers = this.originalCustomers.filter(customer => {
         if (filter.exec(customer._id) || filter.exec(customer.name) || filter.exec(customer.erpCustomerID)) {
           return customer

    }});
  };

}
